import React from "react";
import PublicNavbar from "./PublicNavbar";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

function MainLayout({ isAuthenticated, setIsAuthenticated }) {
  return (
    <>
      <PublicNavbar
        isAuthenticated={isAuthenticated}
        setAuth={setIsAuthenticated}
      />

      <main style={{ paddingTop: "var(--public-navbar-height)" }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default MainLayout;
